import { useDispatch, useSelector } from 'react-redux';
import { prepareRaceGame, resetGame, selectHasRaceStarted, selectRaceTimes } from '../../store/gameStore';
import { IFinished, isGameFinished } from '../../constants/game-state';
import React from 'react';
import { MapOrder, MapOrderById } from '../../game-engine/maps-utils/map-order';
import { formatTime } from '../../game-engine/maps-utils/helper-functions';
import { link_comp } from '../../game-engine/maps-utils/constants';
import useEventListener from '@use-it/event-listener';

export interface IRaceFinishedCallout {}

export function RaceFinishedCallout(props: any) {
  const raceStatus = useSelector(selectHasRaceStarted);

  const idLobby =
    raceStatus.type === 'Finished'
      ? raceStatus.idLobby
      : raceStatus.type === 'StartGame' || raceStatus.type === 'InProgress'
      ? raceStatus.gameOptions.idLobby
      : 0;
  const customLobby = !!idLobby;

  const isGrandPrix = idLobby === -1 ? true : false;

  // TODO Remove multiple initialization
  //console.log('Initialize RaceFinishedCallout');

  const lapTimes = useSelector(selectRaceTimes);
  const dispatch = useDispatch();

  useEventListener('keydown', (keyEvent: KeyboardEvent) => {
    if (customLobby && keyEvent.key === 'r' && raceStatus.type === 'Finished') {
      dispatch(resetGame());
      dispatch(prepareRaceGame(props.optionsCustomMap));
    }
  });

  const [all_best, setAllBest] = React.useState(null);
  React.useEffect(() => {
    if (props.optionsCustomMap)
      fetch(link_comp + '/best/' + props.optionsCustomMap.idLobby)
        .then((res) => res.json())
        .then((all_best) => {
          setAllBest(all_best.score);
        });
  }, []);

  const address = JSON.parse(localStorage.getItem('userData') as any);
  const [personal_best, setPersonalBest] = React.useState(null);
  React.useEffect(() => {
    if (props.optionsCustomMap)
      fetch(link_comp + '/your-best/' + address + '/' + props.optionsCustomMap.idLobby)
        .then((res) => res.json())
        .then((personal_best) => {
          setPersonalBest(personal_best.score);
        });
  }, []);

  if (!isGameFinished(raceStatus)) {
    return null;
  }

  const onClickNextMap = () => {
    dispatch(prepareRaceGame(raceStatus.nextGame));
  };

  const onClickGoBackToMenu = () => {
    dispatch(resetGame());
    // TODO(andrei): Our state management here is terrible
    window.location.reload();
  };

  const onClickRestartMap = () => {
    dispatch(prepareRaceGame(props.optionsCustomMap));
  };

  const mapNumber = MapOrderById[raceStatus.currentMapId];
  const currentMapLapTime = lapTimes[raceStatus.currentMapId];
  const formattedLapTime = currentMapLapTime ? formatTime(currentMapLapTime) : 'Not applicable';
  console.log(isGrandPrix);
  if (isGrandPrix) {
    return (
      <div id="finish" onClick={onClickRestartMap}>
        {/* <p>Congratulation. You finished the map in {formattedLapTime}</p> */}

        <p id="scoreCase">{`Congratulations! You have finished the race in ${formattedLapTime}`}</p>

        <p className="restart-bttn-container">
          Click here or Press <span className="restart-bttn">R</span> to restart the map.
        </p>
      </div>
    );
  } else if (customLobby) {
    let formattedAllBest = all_best ? formatTime(all_best / 1000) : 'Not applicable';
    let formattedPersonalBest = personal_best ? formatTime(personal_best / 1000) : 'Not applicable';
    return (
      <div id="finish" onClick={onClickRestartMap}>
        <p>Congratulation. You finished the map in {formattedLapTime}</p>

        <p id="scoreCase">
          {!all_best || !currentMapLapTime
            ? 'Not available...'
            : currentMapLapTime < all_best / 1000
            ? 'Congratulations! You have beaten the highscore. Now the highscore is ' + formattedLapTime + '.'
            : !personal_best
            ? null
            : currentMapLapTime < personal_best / 1000
            ? "You have a new personal best score! This lobby's highscore is " + formattedAllBest + '.'
            : "This lobby's highscore is " + formattedAllBest + '.'}
        </p>

        <p className="restart-bttn-container">
          Click here or Press <span className="restart-bttn">R</span> to restart the map.
        </p>
      </div>
    );
  }

  if (!raceStatus.nextGame) {
    let totalTime = 0;
    // Means we have finished the tournament
    return (
      <div id="finish" onClick={onClickGoBackToMenu}>
        <div id="totalFinished">Congratulations. You finished all 4 maps in: </div>
        <div id="yourCurrentTimes">
          {MapOrder.map((map, mapIndex) => {
            const mapRaceTime = lapTimes[map];
            if (mapRaceTime !== null) totalTime += mapRaceTime;
            return (
              <div key={mapIndex}>
                Map {mapIndex + 1}: {mapRaceTime ? formatTime(mapRaceTime) : 'Not available'}
              </div>
            );
          })}
        </div>
        <div id="TotalTime">
          Total Time: {totalTime ? formatTime(parseFloat(totalTime.toFixed(4))) : 'Not available'}
          <br />
          {!all_best
            ? 'Not available...'
            : totalTime < all_best
            ? '******** New Best Score ********'
            : !personal_best
            ? null
            : totalTime < personal_best
            ? '******** New Personal Best ********'
            : null}
        </div>
        <div>Click to get back to menu</div>
      </div>
    );
  }

  // console.log(mapNumber, raceStatus.currentMapId, MapOrderById);
  // TODO(andrei): We need a way to handle css
  return (
    <div id="finish" onClick={onClickNextMap}>
      <p>
        Congratulation. You finished map {mapNumber + 1} in {formattedLapTime}
      </p>
      <p>
        Click to move to map {mapNumber + 2} out of {MapOrder.length}
      </p>
      <p style={{ color: 'red', fontWeight: 'bold' }}>loading the map takes a few seconds</p>
    </div>
  );
}
